'use client';

import { faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@pickleballinc/ui/components/search-pages/accordion';
import { useState } from 'react';

import { FAQData } from '@/types/types';

interface FAQAccordionProps {
	data: FAQData[];
}

export const FAQAccordion = ({ data }: FAQAccordionProps) => {
	const [activeAccordionItems, setActiveItems] = useState<string[]>([]);

	return (
		<Accordion value={activeAccordionItems} onValueChange={(value) => setActiveItems(value)} type="multiple" className="w-full">
			{data?.map((item, i) => (
				<AccordionItem key={item.title + i} value={item.title + i} className="border-b border-blue-200">
					<AccordionTrigger className="bg-white sm:p-4" asChild>
						<div className="flex justify-between gap-2 bg-white !text-base !font-bold !text-gray-900 hover:cursor-pointer sm:!text-lg">
							{item.title}
							{activeAccordionItems.includes(item.title + i) ? (
								<FontAwesomeIcon icon={faChevronUp} />
							) : (
								<FontAwesomeIcon icon={faChevronDown} />
							)}
						</div>
					</AccordionTrigger>
					<AccordionContent asChild className="bg-white py-4 pt-0 font-medium text-gray-700 sm:pb-4 sm:pl-8 sm:!text-base">
						{item.content}
					</AccordionContent>
				</AccordionItem>
			))}
		</Accordion>
	);
};
